import * as React from 'react';

import { PageTitleBar } from 'components';

const PageBuilderHeader = () => (
  <PageTitleBar showBackButton={false} headerTitle='صفحه اصلی' />
);

export { PageBuilderHeader };
